import React from 'react';
import {  Modal, ModalHeader, ModalBody} from 'reactstrap';

import PropTypes from 'prop-types';
import AreYouSure from '../AreYouSure';

export default class AreYouSureModal extends React.Component {

  constructor(props) {
    super(props);
  }
 
  render() {
    let { isOpen, toggle, className, onSubmit, confirmText, additionalText} = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle} className={'modal-primary ' + className}>
        <ModalHeader toggle={toggle}> Are You Sure?</ModalHeader>
        <ModalBody>
          {additionalText}
          <div>
            <AreYouSure confirmText={confirmText} toggle={toggle} onSubmit={onSubmit} />
          </div>
        </ModalBody>
      </Modal>
    );
  }
}


AreYouSureModal.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

AreYouSureModal.defaultProps = {
  confirmText: "DELETE"
};


// WEBPACK FOOTER //
// ./src/components/AreYouSureModal/AreYouSureModal.js